import { render, staticRenderFns } from "./FriendMenuMobile.vue?vue&type=template&id=4398bb20&scoped=true"
import script from "./FriendMenuMobile.vue?vue&type=script&lang=js"
export * from "./FriendMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./FriendMenuMobile.vue?vue&type=style&index=0&id=4398bb20&prod&scoped=true&lang=css"
import style1 from "./FriendMenuMobile.vue?vue&type=style&index=1&id=4398bb20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4398bb20",
  null
  
)

export default component.exports